var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55556 8H0.913889C0.423055 8 0.0249998 8.44781 0.0249998 9C0.0249998 9.55219 0.423055 10 0.913889 10H3.55556C4.04639 10 4.44445 9.55219 4.44445 9C4.44445 8.44781 4.04722 8 3.55556 8ZM7.11111 0H0.913889C0.423055 0 0.0249998 0.447812 0.0249998 1C0.0249998 1.55219 0.423055 2 0.913889 2H7.11111C7.60194 2 8 1.55219 8 1C8 0.447812 7.60278 0 7.11111 0ZM1.77778 12H0.888889C0.398056 12 0 12.4478 0 13C0 13.5522 0.398056 14 0.888889 14H1.77778C2.26861 14 2.64167 13.5522 2.64167 13C2.64167 12.4478 2.26944 12 1.77778 12ZM5.33333 4H3.12361H0.913889C0.423055 4 0.0249998 4.44781 0.0249998 5C0.0249998 5.55219 0.423055 6 0.913889 6H5.33333C5.82417 6 6.22222 5.55219 6.22222 5C6.22222 4.44781 5.825 4 5.33333 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.cc7b8d4e542a6f7d8dc1a027f41112e8.svg";
export { ForwardRef as ReactComponent };